import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getCart, getCartCount, removeFromCart } from '../utils/cart';
import { FiTrash2 } from 'react-icons/fi';

const Cart = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(getCart());
  }, []);

  const count = getCartCount(items);

  const handleRemoveItem = (slug) => {
    removeFromCart(slug);
    setItems(getCart());
  };

  const getTotalPrice = () => {
    return items.reduce((total, item) => {
      const price = parseFloat(item.price.replace('£', ''));
      return total + (price * item.quantity);
    }, 0);
  };

  return (
    <div className="cart-page">
      <div className="wrapper grid-display">
        <div className="row">
          <div className="col-12">
            <h1 className="cart__title">Your Cart</h1>
            
            {items.length ? (
              <>
                <div className="cart__table">
                  <div className="cart__table-header">
                    <div className="cart__table-cell">Product</div>
                    <div className="cart__table-cell">Price</div>
                    <div className="cart__table-cell">Quantity</div>
                    <div className="cart__table-cell">Total</div>
                    <div className="cart__table-cell"></div>
                  </div>
                  
                  {items.map((item) => (
                    <div key={item.slug} className="cart__table-row">
                      <div className="cart__table-cell">
                        <div className="cart__product-info">
                          <span className="cart__product-code">{item.code}</span>
                          <span className="cart__product-name">{item.name}</span>
                        </div>
                      </div>
                      <div className="cart__table-cell">{item.price}</div>
                      <div className="cart__table-cell">{item.quantity}</div>
                      <div className="cart__table-cell">
                        £{(parseFloat(item.price.replace('£', '')) * item.quantity).toFixed(2)}
                      </div>
                      <div className="cart__table-cell">
                        <button 
                          className="cart__delete-btn"
                          onClick={() => handleRemoveItem(item.slug)}
                          aria-label="Remove item"
                        >
                          <FiTrash2 />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
                
                <div className="cart__summary">
                  <div className="cart__summary-row">
                    <span className="cart__summary-label">Total:</span>
                    <span className="cart__summary-total">£{getTotalPrice().toFixed(2)}</span>
                  </div>
                </div>
                
                <div className="cart__actions">
                  <button className="cart__checkout-btn">Checkout</button>
                  <Link className="mono cart__back-link" to="/shop">
                    Back to shop
                  </Link>
                </div>
              </>
            ) : (
              <div className="cart__empty">
                <div className="cart__empty-title">Your cart is empty</div>
                <div className="cart__empty-subtitle">Add some items to get started</div>
                <Link className="cart__empty-btn" to="/shop">
                  Continue Shopping
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
